export const settingKeyToRootKey = (key: string) => {
  return `${key.split(':')[0]}:`;
};
